import React, { memo, ReactElement } from "react";

function CrossSellM2TickIcon(): ReactElement {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="18" cy="18" r="8" fill="#1BA672" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.394 15.3492C22.6991 15.6688 22.6873 16.1752 22.3677 16.4802L17.2805 21.3362C16.9714 21.6313 16.4849 21.6313 16.1758 21.3362L13.6322 18.9082C13.3126 18.6031 13.3008 18.0967 13.6059 17.7771C13.911 17.4575 14.4174 17.4458 14.737 17.7508L16.7281 19.6515L21.263 15.3229C21.5826 15.0178 22.0889 15.0296 22.394 15.3492Z"
                fill="white"
            />
        </svg>
    );
}

export default memo(CrossSellM2TickIcon);
